<template>
  <crud-update :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @update="update"
               @close="$emit('close')"
  >
    <branch-form ref="form" v-model="form" :input-errors="inputErrors"/>
  </crud-update>
</template>

<script>

import BranchProvider from "../../../../providers/BranchProvider";

import {CrudUpdate, ClientError} from '@dracul/common-frontend'

import BranchForm from "../BranchForm";


export default {
  name: "BranchUpdate",

  components: {BranchForm, CrudUpdate},

  props: {
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },

  data() {
    return {
      title: 'delivery.branch.editing',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      id: this.item.id,
      form: {
        name: this.item.name,
        location: this.item.location ? this.item.location : {
          localityFilter: null,
          address: '',
          floor: '',
          apartment: '',
          latitude: null,
          longitude: null,
          country: '',
          province: '',
          locality: '',
          postalCode: ''
        },
        isDefault: this.item.isDefault
      }
    }
  },
  methods: {
    update() {
      if (this.$refs.form.validate()) {
        this.loading = true
        BranchProvider.updateBranch(this.id, this.form).then(r => {
              if (r) {
                this.$emit('itemUpdated', r.data.updateBranch)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }
  },
}
</script>

<style scoped>

</style>

